



























































import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class protocol extends Vue {

    
    created() {
    }
    

   

   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/protocol/protocol.vue